<template>
    <div
        ref="antenniTVSaatavuusModalContent"
        role="dialog"
        aria-modal="true"
        aria-labelledby="id-modalHeadingAntenniTV"
        @keydown.tab="trapFocus"
    >
        <header class="modal-header">
            <h1
                id="id-modalHeadingAntenniTV"
                ref="modalHeadingAntenniTV"
                tabindex="0"
                @keydown.tab="handleHeadingTab"
            >
                {{ header }}
            </h1>
            <button
                ref="modalButtonAntenniTV"
                type="button"
                class="btn-close"
                :aria-label="closeModalAriaLabel"
                @click="close"
                @keydown.esc="close"
            />
        </header>
        <section class="modal-body modal-font">
            <!-- eslint-disable vue/no-v-html -->
            <span v-html="textContent" />
            <!--eslint-enable-->
            <dynamic-table
                :table-data="data.tableData"
                :table-heading="tableTitle"
            />
        </section>
    </div>
</template>

<script lang="ts">
    import { Component, Vue, Prop } from "vue-facing-decorator"
    import DynamicModalData from "@/models/dynamicmodaldata"
    import DynamicTable from "@/components/DynamicTable.vue"

    @Component({
        components: {
            "dynamic-table": DynamicTable
        }
    })
    export default class AntenniTVSaatavuusModal extends Vue {
        @Prop({ type: Boolean, default: false }) componentNameIsSet!: boolean

        mounted(): void {
            if (this.componentNameIsSet === true) {
                this.$nextTick(() => {
                    (this.$refs.modalHeadingAntenniTV as HTMLHeadingElement).focus()
                })
            }
        }

        close(): void {
            this.$store.dispatch("setModalComponentName", "")
        }

        get data(): DynamicModalData | null {
            return this.$store?.getters.modalData ?? null
        }

        get textContent(): string | null {
            return this.data?.textContent ?? ""
        }

        get header(): string | null {
            return this.data?.header ?? ""
        }

        get tableTitle(): string | null {
            return this.$t("App.TVSaatavuus.Kanavatiedot") ?? ""
        }

        get closeModalAriaLabel(): string | undefined {
            return this.$t("App.Close")
        }

        trapFocus(event: KeyboardEvent) {
            const focusableElementsString = "a[href], button:not([disabled])"
            let focusableElements: HTMLElement[] = []

            if (this.$refs.antenniTVSaatavuusModalContent instanceof HTMLElement) {
                focusableElements = Array.from((this.$refs.antenniTVSaatavuusModalContent as Element).querySelectorAll<HTMLElement>(focusableElementsString))
            }

            const firstTabStop = focusableElements[0]
            const lastTabStop = focusableElements[focusableElements.length - 1]

            // Tarkistetaan, mik� event ja mik� modaalin elementti kyseess� ja siirryt��n sen mukaan
            if (event.key === "Tab" || event.keyCode === 9) {
                if (event.shiftKey) /* shift + tab */ {
                    if (document.activeElement === firstTabStop) {
                        event.preventDefault()
                        lastTabStop?.focus()
                    }
                    else {
                        const index = focusableElements.indexOf(document.activeElement as HTMLElement)
                        const element = focusableElements[index - 1] as HTMLElement
                        element.focus()
                        event.preventDefault()
                    }
                }
                else /* tab */ {
                    if (document.activeElement === lastTabStop) {
                        event.preventDefault()
                        firstTabStop?.focus()
                    }
                    else {
                        const index = focusableElements.indexOf(document.activeElement as HTMLElement)
                        const element = focusableElements[index + 1] as HTMLElement
                        element.focus()
                        event.preventDefault()
                    }
                }
            }
        }

        handleHeadingTab(event: KeyboardEvent): void {
            if (event.shiftKey) /* shift + tab */ {
                (this.$refs.modalButtonAntenniTV as HTMLButtonElement).focus()
                event.preventDefault()
            }
        }
    }
</script>
